import React from 'react';
import './index.css';
import {storeItem} from "./const";
import {configArrDto} from "../../common/config";
import {useNavigate} from "react-router-dom"; // This will contain the CSS for our grid


export const FoodStoreGrid = ({ stores }: {
  stores: any[]
}) => {
  return (
    <div className="food-store-grid">
      {stores.map(store => (
        <FoodStoreCard  logo={store.imgSrc} name={store.title} id={store.id} />
      ))}
    </div>
  );
};

const FoodStoreCard = (props :storeItem) => {
  const { logo, name, id } = props;
  let navigate = useNavigate();
  return (
    <div className="food-store-card" onClick={() => {
      navigate(`/feature-detail/${id}`);
    }}>
      <img src={logo} alt={name} />
      <div className="store-name">{name}</div>
    </div>
  );
};



// Sample usage of FoodStoreGrid with configurable props

